import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { RSE_LINKS } from '../config/index.ts';

// Define interface for the props
interface IRSECard {
  title: string;
  description: string;
  icon: string;
}

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'RSEcard',
  props: {
    title: null,
    description: null,
    icon: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  description: string;
  icon: string;
};



// Refs
const content = ref<{ [key: string]: string }>(window.content);

// Function to open the correct link in a new tab
const openLink = () => {
  for (const key in RSE_LINKS) {
    if (props.icon.includes(key)) {
      window.open(RSE_LINKS[key], '_blank');
      return;
    }
  }
};

return { __sfc: true,props, content, openLink }
}

})